import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import WifiCalling3Icon from "@mui/icons-material/WifiCalling3";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { error, success, misc } from "app/themes/colors";
import {
  CALL_STATUS_ANSWERED,
  CALL_STATUS_MISSED,
  CALL_STATUS_NO_ANSWER,
  CALL_STATUS_RINGING,
} from "constants/suno-comms";
import Box from "@mui/material/Box";

type CallStatusProps = {
  status: string;
};
export default function CallStatus({ status }: CallStatusProps) {
  if (status.toLocaleLowerCase() === CALL_STATUS_MISSED) {
    return (
      <Stack direction="row" spacing={1} sx={{ color: error[700] }}>
        <PhoneMissedIcon sx={{ fontSize: "20px" }} />
        <Typography sx={{ fontSize: "14px" }}>{status}</Typography>
      </Stack>
    );
  } else if (status.toLocaleLowerCase() === CALL_STATUS_ANSWERED) {
    return (
      <Stack direction="row" spacing={1} sx={{ color: success[700] }}>
        <SupportAgentIcon sx={{ fontSize: "20px" }} />
        <Typography sx={{ fontSize: "14px" }}>{status}</Typography>
      </Stack>
    );
  } else if (status.toLocaleLowerCase() === CALL_STATUS_NO_ANSWER) {
    return (
      <Stack direction="row" spacing={1} sx={{ color: error[700] }}>
        <SupportAgentIcon sx={{ fontSize: "20px" }} />
        <Typography sx={{ fontSize: "14px" }}>{status}</Typography>
      </Stack>
    );
  } else if (status.toLocaleLowerCase() === CALL_STATUS_RINGING) {
    return (
      <Stack direction="row" spacing={1} sx={{ color: misc["darkYellow"] }}>
        <Box
          sx={{
            animation: "ringing 1s infinite",
            "@keyframes ringing": {
              "0%": { transform: "translateX(0)" },
              "50%": { transform: "translateX(6px)" },
              "100%": { transform: "translateX(0)" },
            },
            animationTimingFunction: "cubic-bezier(0.4, 0, 0.6, 1)",
          }}
        >
          <WifiCalling3Icon sx={{ fontSize: "20px" }} />
        </Box>
        <Typography sx={{ fontSize: "14px" }}>{status}</Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={1}>
      <LocalPhoneIcon sx={{ fontSize: "20px" }} />
      <Typography sx={{ fontSize: "14px" }}>{status}</Typography>
    </Stack>
  );
}
